import styled from 'styled-components';
import { DialogActions } from '@material-ui/core';
import { COLORS, FONT_COLORS } from 'constants/design';
export const StyledContainer = {
  top: '102%',
  right: '1.3%',
};
export const StyledList = {
  width: 350,
  backgroundColor: 'white',
};
export const StyledAreaList = {
  width: 'fit-content',
  backgroundColor: 'white',
};
export const StyledListItem = {
  padding: '24px 16px',
  borderTop: '1px solid #EBEEF1',
  cursor: 'pointer',
};
export const SelectedStyledListItem = {
  backgroundColor: '#0151A3',
  padding: '24px 16px',
};
export const StyledTitle = {
  fontFamily: 'Roboto',
  fontSize: '17px',
  fontWeight: 500,
  lineHeight: '20px',
};
export const StyledPrimaryChipLabel = {
  padding: '4px 8px',
  backgroundColor: '#0075C9',
  color: 'white',
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontWeight: 500,
};
export const StyledPrChipLabel = {
  backgroundColor: 'rgb(255, 52, 0)',
  padding: '4px 8px',
  color: 'white',
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontWeight: 500,
};

export const StyledSecondaryChipLabel = {
  padding: '4px 8px',
  backgroundColor: '#D5DAE1',
  color: '#727A83',
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontWeight: 500,
};
export const StyledGridItem = { width: '100%', marginTop: '30px' };
export const StyledTitleSubIcon = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  color: '#464E58',
  fontSize: '18px',
  lineHeight: '24px',
};
export const StyledDescription = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  color: '#8A929C',
  fontSize: '14px',
  lineHeight: '20px',
};
export const StyledSpacingTop = { marginTop: '16%' };
export const StyledField = {
  width: '100%',
};
export const StyledGridContainer = {
  height: 'fit-content',
  background: '#FFF',
  alignContent: 'baseline',
};
export const StyledHeadContainer = { padding: '26px' };
export const StyledSecondHeadContainer = { padding: '6px' };

export const StyledTitleAssignement = {
  color: '#717983',
  fontSize: '14px',
  fontWeight: 400,
};
export const StyledCard = {
  borderRadius: '4px',
  background: '#FFF',
  width: '287px',
  height: '44px',
  padding: '10px 12px',
  border: '1px solid #D5DAE1',
};
export const StyledSpan = {
  color: '#000',
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Roboto',
  cursor: 'pointer',
};
export const StyledToolTip = {
  borderRadius: '29px',
  backgroundColor: '#D5DAE1',
  height: '23px',
  width: '31px',
  justifyContent: 'center',
  display: 'flex',
  paddingTop: '2px',
};
export const StyledSpacingGrid = { marginTop: '-5px' };
export const StyledSpacing = {
  marginTop: '-2px',
  cursor: 'pointer',
};
export const StyledButton = {
  color: '#0075C9',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  fontFamily: 'Roboto',
  textTransform: 'unset',
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid white',
};
export const StyledSecondaryButton = {
  color: '#FF3400',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  fontFamily: 'Roboto',
  textTransform: 'unset',
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid #FF523A',
};

export const StyledPrimaryButton = {
  backgroundColor: '#0075C9',
  padding: '8px 16px',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  fontFamily: 'Roboto',
  color: '#FFF',
  textTransform: 'unset',
  borderRadius: '4px',
  border: '1px solid white',
};
export const StyledFieldSpacing = {
  width: '100%',
  marginTop: '-20px',
};

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  padding: 20px 30px;

  .moveButton {
    border: 1px solid ${COLORS.PRIMARY_BUTTON_BLUE};
    background-color: ${COLORS.PRIMARY_BUTTON_BLUE};
    color: ${COLORS.WHITE};
    &:hover {
      background-color: ${COLORS.PRIMARY_BUTTON_BLUE};
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;
export const StyleTitleDialog = {
  color: FONT_COLORS.BLACK,
  fontSize: '32px',
  lineHeight: '40px',
  marginBottom: '20px',
};
export const StyleDescriptionDialog = {
  fontSize: '14px',
  lineHeight: '20px',
  color: FONT_COLORS.DARK_BLACK_GREY,
};
export const StyleNameManager = {
  color: FONT_COLORS.BLACK,
  fontSize: '32px',
  lineHeight: '40px',
};
export const StyledCardManager = {
  padding: '7px 8px',
  backgroundColor: '#E6F1FA',
  borderRadius: '4px',
  marginTop: '10px',
  width: 'fit-content',
};

export const StyledCheckCardManager = {
  borderRadius: '4px',
  border: '1px solid #EBEEF1',
  background: '#F3F5F7',
  width: 'fit-content',
  padding: '7px 8px',
  marginTop: '10px',
};

export const StyledTitleButton = {
  color: FONT_COLORS.PRIMARY_BLUE,
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: 500,
};

export const StyledTitleCheckedButton = {
  color: '#BCC4CE',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: 500,
};

export const StyledIcon = {
  width: '18px',
  height: '18px',
  cursor: 'pointer',
};

export const StyledAddIcon = {
  width: '18px',
  height: '18px',
  cursor: 'pointer',
  transform: 'rotate(45deg)',
};
export const StyledSlaContainer = {
  padding: '6px 6px 6px 6px',
  border: '1px solid #0075C9',
  borderRadius: '92px',
  backgroundColor: '#FFFFFF',
};

export const StyledWarningContainer = {
  padding: '6px 6px 6px 6px',
  border: '1px solid rgba(255, 140, 0, 1)',
  borderRadius: '92px',
  backgroundColor: 'rgba(255, 255, 255, 1)',
};
export const StylePendingContainer = {
  background: 'rgba(230, 241, 250, 1)',
  borderRadius: '92px',
  padding: '6px 6px 6px 6px',
};
export const StyleSecondaryContainer = {
  padding: '6px 6px 6px 6px',
  border: '1px solid rgba(213, 218, 225, 1)',
  borderRadius: '92px',
  backgroundColor: 'rgba(255, 255, 255, 1)',
};
export const StyledElement = {};
export const StyledTitleRoles = {
  color: '#717983',
  fontSize: '14px',
  fontWeight: 400,
  marginBottom: '5px',
};
